import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import displayFilterBarButtons from 'src/components/Dashboard/helpers';
import { FilterBar } from 'src/components/Filter';
import {
  ALL_PORTFOLIO_USERS, LIST_FILTER_ALL, PORTFOLIO_USER_ROLE_ADMIN,
  PORTFOLIO_USER_ROLE_OWNER, PORTFOLIO_USER_ROLE_STANDARD,
  PORTFOLIO_USER_ROLE_VIEWER,
} from 'src/util/constants';

/**
 * @param {object} props
 * @param {string} props.activeState - Whether the element is active or inactive.
 * @param {Function} props.setFilterFunc - Function that sets the active state of the
 * element.
 * @param {ALL_PORTFOLIO_USERS | PORTFOLIO_USER_ROLE_OWNER |
 * PORTFOLIO_USER_ROLE_ADMIN | PORTFOLIO_USER_ROLE_STANDARD |
 * PORTFOLIO_USER_ROLE_VIEWER} props.roleType - Selected user role or the default
 * All portfolio users.
 * @returns {React.ReactComponentElement} PortfolioActiveStatusFilter component.
 */
function PortfolioActiveStatusFilter({ activeState, setFilterFunc, roleType = null }) {
  const intl = useIntl();
  const filterBarButtons = displayFilterBarButtons(intl, activeState);

  /**
   * Updates the filter state based on the provided group and value.
   * @param {object} param0 - An object containing the group and value to update the filter with.
   * @param {string} param0.group - The group to update the filter for.
   * @param {string} param0.value - The value to update the filter to.
   * @returns {void}
   */
  const updateFilter = ({ group, value }) => {
    if (value === LIST_FILTER_ALL) {
      setFilterFunc({ roleType: ALL_PORTFOLIO_USERS, activeState: LIST_FILTER_ALL });
      return;
    }
    if (group === 'active') {
      setFilterFunc({ activeState: value, roleType });
    }
  };

  return (
    <FilterBar buttons={filterBarButtons} onButtonClickFunc={updateFilter} />
  );
}

PortfolioActiveStatusFilter.propTypes = {
  activeState: PropTypes.string.isRequired,
  setFilterFunc: PropTypes.func.isRequired,
  roleType: PropTypes.string,
};

export default PortfolioActiveStatusFilter;
